/**
 * Avaliação obrigatória ao concluir um caso de pesquisa. Vocabulário fechado: cada resposta
 * corresponde a um ajuste determinístico do prompt, nunca a texto livre tratado como instrução.
 */
export const CASE_OUTCOMES = ["used_fully", "used_partially", "not_used"] as const;
export const CASE_ISSUES = ["weak_sources", "missing_routes", "too_many_questions", "too_generic", "technical_error", "none"] as const;
export const CASE_DEPTHS = ["shorter", "ok", "deeper"] as const;

export type CaseOutcome = typeof CASE_OUTCOMES[number];
export type CaseIssue = typeof CASE_ISSUES[number];
export type CaseDepth = typeof CASE_DEPTHS[number];

export const CASE_NOTES_MAX = 300;
/** A partir desta sequência de casos pulados, o formulário avisa o usuário. */
export const SKIP_STREAK_WARNING = 3;

export const OUTCOME_LABELS: Record<CaseOutcome, string> = {
  used_fully: "Usei como base",
  used_partially: "Usei em parte",
  not_used: "Não usei"
};

export const ISSUE_LABELS: Record<CaseIssue, string> = {
  weak_sources: "Fontes fracas ou desatualizadas",
  missing_routes: "Faltou rota ou jurisdição",
  too_many_questions: "Perguntas de esclarecimento demais",
  too_generic: "Genérico ou raso",
  technical_error: "Erro técnico ou legal",
  none: "Nada"
};

export const DEPTH_LABELS: Record<CaseDepth, string> = {
  shorter: "Mais curta",
  ok: "Adequada",
  deeper: "Mais aprofundada"
};

export interface CaseFeedbackAnswers {
  outcome: CaseOutcome;
  rating: number;
  issues: CaseIssue[];
  depth?: CaseDepth;
}

/** Nota baixa sem dizer o que atrapalhou não gera ajuste algum; por isso os chips passam a ser exigidos. */
export const issuesRequired = (rating: number) => rating <= 3;

/**
 * Respostas que se contradizem entre si. A interface pede confirmação e o servidor grava
 * consistency='conflict' com peso neutro — os chips continuam valendo por serem mais específicos.
 */
export function detectFeedbackConflict(answers: CaseFeedbackAnswers) {
  const onlyNone = answers.issues.length > 0 && answers.issues.every((issue) => issue === "none");
  return (answers.outcome === "used_fully" && answers.rating <= 2)
    || (answers.outcome === "not_used" && answers.rating >= 4)
    || (answers.rating <= 2 && onlyNone);
}
